import styled, { createGlobalStyle } from 'styled-components';
import GothamBold from '../fonts/GothamBold.ttf';
import GothamBook from '../fonts/GothamBook.ttf';
import GothamLight from '../fonts/GothamLight.ttf';
import GothamMedium from '../fonts/GothamMedium.ttf';

export default createGlobalStyle`
  :root {
    /* GLOBAL */
    --box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);

    --primary: #fc0;
    --secondary: #424242;

    --color: #333333;
    --color-scroll: #888;
    --background-color: #fff;
    --background: #f3f3f3;

    /* SKELETON */
    --background-skeleton: #ddd;
    --background-shimmer: rgba(255, 255, 255, 0.2);
    
    /* BUTTONS */
    --danger: #dc3545;
    --success: #28a745;
    --warning: #ffc107;
    --welcome: #17a2b8;
    --orange: #e59037;
    --notification: #ffffff;

    --danger-hover: #c82333;
    --success-hover: #218838;
    --warning-hover: #e0a800;
    --welcome-hover: #138496;
    --notification-hover: #eeeeee;
  }

  .dark {
    --color: #f0f0f0;
    --color-scroll: #fff;
    --background-color: #242424;
    --background: #333;
    --background-skeleton: #777;
    --background-shimmer: rgba(0, 0, 0, 0.1);
  }

  @font-face {
    font-family: "GothamBold";
    font-size: 1.6rem;
    line-height: 2.1rem;
    src: url(${GothamBold});
  }
  @font-face {
    font-family: "GothamBook";
    font-size: 1.6rem;
    line-height: 2.1rem;
    src: url(${GothamBook});
  }
  @font-face {
    font-family: "GothamMedium";
    font-size: 1.6rem;
    line-height: 2.1rem;
    src: url(${GothamMedium});
  }
  @font-face {
    font-family: "GothamLight";
    font-size: 1.6rem;
    line-height: 2.1rem;
    src: url(${GothamLight});
  }

  html {
    font-size: 62.5%;
    overflow: hidden;
  }

  * {
    font-family: "GothamLight", Arial, Helvetica, sans-serif;
    box-sizing: border-box;
    border: 0;
    margin: 0;
    padding: 0;
    font-size: 1.6rem;
    vertical-align: baseline;
    transition: background .2s, color .2s;
    user-select: none;
    outline: none;
  }

  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-track {
    background: #474545;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: var(--color-scroll);
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  img {
    max-width: 100%;
    display: block;
  }

  body {
    line-height: 1;
    background-color: var(--background);
    color: var(--color);
  }

  ol, ul {
    list-style: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .leaflet-top, .leaflet-bottom {
    z-index: 998 !important;
  }

  .leaflet-control-attribution > * {
    font-size: 1.2rem;
    font-family: "GothamLight";
    text-decoration: none;
    color: #000 !important;
  }

  .leaflet-popup-content {
    width: auto !important;
  }

  .leaflet-control-attribution a:hover {
    text-decoration: none;
  }
`;

export const Animation = styled.div`
  margin: 20px;
  animation: animacao 0.5s ease forwards;
  @keyframes animacao {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`;

export const Button = styled.button`
  font-family: 'GothamBold';
  padding: 7px 10px;
  text-transform: uppercase;
  transition: 0.3s;
  font-size: 1.4rem;
  cursor: ${({ cursor }) => cursor || 'pointer'};
  background: ${({ typeName }) => `var(--${typeName})`};
  color: ${({ typeName }) => (typeName === 'warning' ? '#000000aa' : '#fff')};

  &:disabled {
    color: #404040;
    background: #c0c0c0;
    cursor: not-allowed;
  }

  &:hover:not(&:disabled) {
    background: ${({ typeName }) => `var(--${typeName}-hover)`};
  }
`;

export const FormController = styled.div`
  display: flex;
  align-items: center;
  grid-column: ${({ grid }) => grid || 'initial'};
  grid-row: ${({ gridRow }) => gridRow || 'initial'};
  width: 100%;
`;

export const Status = styled.div`
  color: ${({ typeName }) => `var(--${typeName})`};
  text-transform: capitalize;
  max-width: 150px;
  font-family: 'GothamBold';
`;

export const ErrorMessage = styled.span`
  color: var(--danger);
  font-size: 1.4rem;
`;
